export default "__VITE_ASSET__CzH_Fj6b__"